import React from "react";

interface IProps {
  condition: boolean;
  children: React.ReactNode;
}

export const If: React.FC<IProps> = ({ children, condition }) =>
  condition ? <>{children}</> : null;
